import React from 'react';
interface BulkrrLogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}
export function BulkrrLogo({
  variant = 'full',
  size = 'md',
  className = ''
}: BulkrrLogoProps) {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
    xl: 'h-16'
  };
  const iconSizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-16 h-16'
  };
  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-5xl'
  };
  return <div className={`flex items-center gap-2 ${sizeClasses[size]} ${className}`} data-id="element-3191" data-mp="s3ao1uboq50w">
      {/* Icon */}
      <div className={`relative flex-shrink-0 bg-primary text-primary-foreground rounded-2xl flex items-center justify-center transform rotate-3 ${iconSizeClasses[size]}`} data-id="element-3192" data-mp="e8i48jori2oi">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-3/5 h-3/5" data-id="element-3193" data-mp="4d6vqj3y5rp7">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" data-id="element-3194" data-mp="25vhz3krvm9o7" />
          <path d="M3 6h18" data-id="element-3195" data-mp="25xc9441m0hdi" />
          <path d="M16 10a4 4 0 0 1-8 0" data-id="element-3196" data-mp="2jur37m2t5dbt" />
        </svg>
        {/* Subtle leaf/check accent */}
        <div className="absolute -bottom-1 -right-1 bg-success rounded-full p-0.5 border-2 border-background" data-id="element-3197" data-mp="2ew63dnrgwvnw">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" className="w-2.5 h-2.5" data-id="element-3198" data-mp="1r5tuoaoeeuw9">
            <polyline points="20 6 9 17 4 12" data-id="element-3199" data-mp="20xg4q3p02nxf" />
          </svg>
        </div>
      </div>

      {/* Wordmark */}
      {variant === 'full' && <span className={`font-bold tracking-tight text-foreground ${textSizeClasses[size]}`} data-id="element-3200" data-mp="18fkic7ywdmqu">
          Bulkrr
        </span>}
    </div>;
}